import { PAGE_PATHS } from '@/app/constants/pages';
import PeriodInitializer from '@/components/periodDetails/PeriodInitializer';
import { PeriodProvider } from '@/context/PeriodContext';
import Admin from '@/pages/admin';
import Approvers from '@/pages/Approvers';
import Redirect from '@/pages/redirecting';
import Systems from '@/pages/Systems';
import PERMISSION_ROLES, { PAGE_NAMES } from '@constants/roles';
import RequireAuth from '@features/auth/RequireAuth';
import RequireLogin from '@features/auth/RequireLogin';
import Layout from '@pages/layout';
import Login from '@pages/login';

import { Route, Routes } from 'react-router-dom';

function AppRoute() {
  return (
    <PeriodProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<RequireLogin />}>
          <Route element={<PeriodInitializer />}>
            <Route element={<Layout />}>
              {/* public routes */}
              <Route path="/" element={<Redirect />} />

              <Route path={PAGE_PATHS.APPROVERS} element={<Approvers />} />
              <Route path={PAGE_PATHS.SYSTEMS} element={<Systems />} />
              {/* protected routes for ADMIN */}
              <Route element={<RequireAuth roles={PERMISSION_ROLES[PAGE_NAMES.ADMIN]} />}>
                <Route path={PAGE_PATHS.ADMIN} element={<Admin />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </PeriodProvider>
  );
}

export default AppRoute;
